import { ShareAltOutlined } from "@ant-design/icons";
import Link from "next/link";
import LinkPageRenderer from "./LinkPageRenderer";
import dynamic from "next/dynamic";
import { getThemeStyle, linkPageHeading, normalizeLinkPageVersion } from "./linkPageBuilderUtils";
import { BONJOURNO_LOGOS } from "../../utils/brandImages";

const ProfileShareButton = dynamic(() => import("./ProfileShareButton"));

// The public route and marketing previews share the same surface and renderer.
export default function PublicLinkPageSurface({
  profileInfo,
  version,
  theme,
  preview = false,
  device = "auto",
  bookingPreview,
  pageUrl,
  shortPath,
  selectedItemId,
  onSelectItem,
  onItemClick,
  autoOpenBooking,
  selectedSectionId,
  onSelectSection,
  pageId,
  reactions,
  articles,
}) {
  const isDark = theme !== "_light";
  const themeStyle = getThemeStyle(version.theme);
  const logoSource = BONJOURNO_LOGOS[isDark ? "dark" : "light"];
  const logo = (
    <img
      src={logoSource.src}
      srcSet={logoSource.srcSet}
      sizes="60px"
      alt="BonJourno"
      width={60}
      height={22.2}
      style={{ display: "block", width: 60, height: 22.2 }}
    />
  );
  return (
    <div
      className={`publicLinksPage publicLinksPage--${
        isDark ? "dark" : "light"
      } publicLinksPage--${device}${preview ? " publicLinksPage--preview" : ""}${
        normalizeLinkPageVersion(version).sections.find((section) => section.isVisible !== false)?.showProfile
          ? " publicLinksPage--hero"
          : ""
      }`}
      style={themeStyle}
    >
      <div
        className="publicLinksPage__topbar"
      >
        {preview ? (
          <span className="publicLinksPage__logoLink">{logo}</span>
        ) : (
          <Link
            href="/"
            className="publicLinksPage__logoLink"
            aria-label="Go to home page"
          >
            {logo}
          </Link>
        )}
        {preview ? (
          <span className="publicLinksPage__previewShare" aria-hidden="true">
            <ShareAltOutlined />
          </span>
        ) : (
          <ProfileShareButton
            className="publicLinksPage__shareButton"
            iconOnly
            linkPageOnly
            pageUrl={pageUrl}
            shortPath={shortPath}
            heading={linkPageHeading(version, profileInfo)}
            profileInfo={profileInfo}
            themeStyle={themeStyle}
          />
        )}
      </div>
      <div className="publicLinksPage__inner">
        <LinkPageRenderer
          profileInfo={profileInfo}
          version={version}
          device={device}
          showEmptyState={!preview}
          disableLinks={preview}
          bookingPreview={bookingPreview}
          selectedItemId={selectedItemId}
          onSelectItem={onSelectItem}
          onItemClick={onItemClick}
          autoOpenBooking={autoOpenBooking}
          selectedSectionId={selectedSectionId}
          onSelectSection={onSelectSection}
          pageId={pageId}
          reactions={reactions}
          articles={articles}
        />
      </div>
    </div>
  );
}
